/**
 * Interface for the 'UiApp' data
 */

import type { Job } from '@cdw-ae/job-service';

import type { FieldUpdatesSummary } from '../models/bulk-update-action-models';

export interface CdwBulkUpdateActionEntity {
  id: string; // Primary ID
  isNextButtonDisabled: boolean;
  isCancellingJob: boolean;
  bulkUpdateActionJob?: Job;
  fieldUpdatesSummary: FieldUpdatesSummary[];
}

export enum BulkUpdateActions {
  getBulkUpdateActionJob = '[CdwBulkUpdateAction] get bulk update action job',
  unsubscribeBulkUpdateActionJob = '[CdwBulkUpdateAction] unsubscribe to bulk update action job',
  getBulkUpdateActionSuccess = '[CdwBulkUpdateAction] get bulk update action success',
  getFieldUpdatesSummary = '[CdwBulkUpdateAction] get field updates summary',
  getFieldUpdatesSummarySuccess = '[CdwBulkUpdateAction] get field updates summary success',
}
